import { RoleInfo } from "./roleInfo.class";

export class RoleManagerState {
    roles: RoleInfo[] = [];
    roleToEdit: RoleInfo = null;
    returnFromEdit: boolean = false;
}